import React, { Component } from 'react';

class Title extends Component {
	render() {
		return (
			<div>
				<div className="dp-instructions">System Requirements Check</div>
				<div className="dp-instructions-subtitle">
					To receive approval for your upcoming study, we will check if your
					device is compatible. There are 3 steps to confirm compatibility.
					Please click “GO” when all 3 lights are green.
				</div>
			</div>
		);
	}
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/tech-check/Title.js